export default __webpack_public_path__ + "static/media/spinner-sml--fast.e6e133f5.svg";